import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream px-5 pb-16 sm:pb-24" data-id="element-103" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl rounded-4xl border border-navy/10 bg-navy-tint px-7 py-10 text-center sm:px-12 sm:py-12" data-id="element-104" data-mp="1o5q2iivokc11">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-navy" data-id="element-105" data-mp="1x4l8puyq5m4c">
          <ShieldCheckIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-106" data-mp="19ehege7feyq0" />
        </span>
        <h2 className="mt-6 text-xl font-extrabold tracking-tight text-navy sm:text-2xl" data-id="element-107" data-mp="14fxtag0npqyp">
          Rimborso Garantito o Lo Tieni Comunque.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink-soft" data-id="element-108" data-mp="1j650fzl7rnk3">
          Se Musica Pronta non fa al caso tuo, scrivici entro 30 giorni per il rimborso completo.
          Nessuna domanda. E se decidi di tenerlo, resta tuo per sempre.
        </p>
      </div>
    </section>;
}